import { Link, Text } from '@amzn/meridian';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom-v5-compat';
import { classes } from 'typestyle';
import { bulkPublishAttributesSummaryPath } from '../../../components/Paths';
import { BULK_ATF_JOB_ID_URL_PARAM } from '../../bulk-publish/constants';
import { atfModalStyles } from '../styles/styles';

export const UploadAtfSuccessModal = ({
  successfullRows,
  jobId,
  bulkPublishJobList,
}: {
  successfullRows: number;
  jobId: string;
  bulkPublishJobList: string[];
}) => {
  const navigate = useNavigate();
  return (
    <div className={classes(atfModalStyles.successModal)}>
      <div>
        <FontAwesomeIcon className={classes(atfModalStyles.successIcon)} icon={faCircleCheck} />
      </div>
      <div className="pt-3" data-cy="sucess-modal-text">
        <Text alignment="center" id="modal-description" type="h100">
          {successfullRows} rows uploaded successfully
        </Text>
        <Text alignment="center" className="pt-3" id="modal-description">
          {bulkPublishJobList.length === 0 ? (
            'Please note that all uploaded values will be in DRAFT state, and will still need to be published'
          ) : (
            <>
              <Link href={`${bulkPublishAttributesSummaryPath}?${BULK_ATF_JOB_ID_URL_PARAM}=${jobId}`} onClick={navigate} type="primary">
                Bulk publishing
              </Link>
              {' has started.'}
            </>
          )}
        </Text>
      </div>
    </div>
  );
};
